import React, { useLayoutEffect, useRef } from "react";
import { Button, Image } from "react-bootstrap";
import { GlobalStateContext } from "../GlobalStates";
import { useTranslation } from "react-i18next";
import { clearAuthSession, emptyAuthState } from "../../helperData/panelRoutes";
import exitpanelIcon from "../../asset/icons/exitpanelIcon.svg";

const RightSidebarButton = () => {
    const { auth, setAuth } = React.useContext(GlobalStateContext);
    const {
        t,
        i18n: { dir, language },
    } = useTranslation();
    const ref = useRef(null);

    useLayoutEffect(() => {
        const img = ref.current;
        if (dir(language) === "ltr") {
            img.style.transform = "rotate(180deg)";
        } else {
            img.style.removeProperty("transform");
        }
    }, [dir, language]);

    const logoutHandle = () => {
        clearAuthSession();
        setAuth(emptyAuthState());
    };

    return (
        <Button className="sidebar_button" onClick={logoutHandle}>
            <Image
                ref={ref}
                src={exitpanelIcon}
                className="image"
                alt="exit panel"
            />

            <span className="text">{t("LogOut.Button")}</span>
        </Button>
    );
};

export default RightSidebarButton;
